import axios from "axios";
import React, { useState, useEffect, useContext, useMemo } from "react";
import { useParams } from "react-router-dom";
import Loading from "../../common/loading";
import Errors from "../../common/error";
import Breadcrumbs from "../../common/breadcumb";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/css/bootstrap.min.css";
import "./news.scss";
import { LangContext } from "../../context/LangContext";

function NewsDetail() {
  const { state } = useContext(LangContext);
  const nep = state.np;
  const { category, slug } = useParams();

  const catUrl = category === "news-&-events" ? "news" : category;
  const API_URL = `${process.env.REACT_APP_URL}${catUrl}/detail/${slug}`;

  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(false);

      try {
        const response = await axios.get(API_URL);
        setDetail(response.data.detail);
      } catch (err) {
        console.error(err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [API_URL]);

  const mainData = useMemo(() => {
    if (!detail) return null;
    return nep ? detail.np : detail.en;
  }, [detail, nep]);

  if (loading) return <Loading />;
  if (error || !mainData) return <Errors />;

  return (
    <>
      <Breadcrumbs PageTitle={mainData.title} />

      <div className="InsidePageContainer">
        <div className="faq-box">
          <div className="wrapper">
            <div className="detail-parent">
              {/* Main Image */}
              {mainData.image && (
                <div className="detail-img mb-4">
                  <img
                    src={mainData.image}
                    alt={mainData.title}
                    className="img-fluid"
                    data-bs-toggle="modal"
                    data-bs-target="#mainImageModal"
                    style={{ cursor: "pointer" }}
                  />
                </div>
              )}

              {/* Multiple Images */}
              {mainData.multi_images && mainData.multi_images.length > 0 && (
                <div className="row g-3 mb-4">
                  {mainData.multi_images.map((item, index) => (
                    <div
                      className="col-lg-3 col-md-4 col-6"
                      key={item.id || index}
                    >
                      <img
                        src={item.doc}
                        alt={`Gallery ${index + 1}`}
                        className="img-fluid rounded shadow-sm"
                        style={{
                          cursor: "pointer",
                          height: "200px",
                          width: "100%",
                          objectFit: "cover",
                        }}
                        data-bs-toggle="modal"
                        data-bs-target={`#galleryModal${index}`}
                      />

                      {/* Modal */}
                      <div
                        className="modal fade NewsDetails"
                        id={`galleryModal${index}`}
                        tabIndex="-1"
                        aria-hidden="true"
                      >
                        <div className="modal-dialog modal-dialog-centered modal-lg">
                          <div className="modal-content">
                            <div className="modal-header">
                              <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                              ></button>
                            </div>

                            <div className="modal-body text-center">
                              <img
                                src={item.doc}
                                alt=""
                                className="img-fluid"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Description */}
              <div className="description">
                <div
                  dangerouslySetInnerHTML={{
                    __html: mainData.description || "",
                  }}
                />
              </div>
            </div>

            {/* Main Image Modal */}
            {mainData.image && (
              <div
                className="modal fade NewsDetails"
                id="mainImageModal"
                tabIndex="-1"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                  <div className="modal-content">
                    <div className="modal-header">
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                      ></button>
                    </div>

                    <div className="modal-body text-center">
                      <img
                        src={mainData.image}
                        alt={mainData.title}
                        className="img-fluid"
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default NewsDetail;
